<template>
  <header class="tw-relative tw-mb-auto tw-mt-5 tw-h-16 tw-w-full tw-p-4">
    <section>
      <router-link :to="{ name: 'auth-sign-in' }">
        <img
          alt="site logo"
          class="tw-inline-flex tw-h-16 tw-w-auto"
          :src="src"
        />
      </router-link>
    </section>
  </header>
</template>

<script setup lang="ts">
const src = new URL("@/assets/branding/TitanHQLogo-white.svg", import.meta.url)
  .href;
</script>
